exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".s2nResizeObserverTarget{position:relative}.resizeObserverFrame{border:0;position:absolute;top:-1000vh;left:-1000vw;right:auto;bottom:auto;width:100%;height:100%}", ""]);

